import React from 'react';
import { useEvents } from '../../../hooks/useEvents';
import EventList from '../../../components/event/EventList';
import { PublicLayout } from '../../../components/layout/PublicLayout';
import { SEOMetaTags } from '../../../components/shared/SEOMetaTags';
import { Input } from '../../../components/ui/input';
import { Button } from '../../../components/ui/button';
import { Award } from 'lucide-react';
import { Link } from 'react-router-dom';

const EventsPage: React.FC = () => {
  const { events, loading } = useEvents({ is_active: true });
  const filteredEvents = events;

  return (
    <PublicLayout>
      <SEOMetaTags
        title="Événements | ERNEST NZOGOUG"
        description="Découvrez les événements à venir et passés sur ERNEST NZOGOUG. Achetez vos tickets et participez à des expériences inoubliables."
        url="https://nzofoug.com/events"
      />
      <div className="min-h-screen relative pt-20">
        {/* Background Image avec Overlay */}
        <div 
          className="fixed inset-0 z-0 bg-center bg-no-repeat bg-cover"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1500&q=80)',
            transform: 'translateZ(0)',
            willChange: 'transform',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/90 via-black/80 to-black/95 backdrop-blur-[2px]" />
        </div>
        <div className="relative z-10 container mx-auto px-4 py-12">
          {/* En-tête */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Événements
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Découvrez nos événements à venir et passés. Achetez des tickets et participez à des expériences inoubliables.
            </p>
          </div>

          {/* Liste des événements */}
          {loading ? (
            <div className="flex justify-center items-center min-h-[400px]">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-400"></div>
            </div>
          ) : filteredEvents.length > 0 ? (
            <EventList events={filteredEvents} loading={false} useSlug={true} />
          ) : (
            <div className="text-center py-16 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl">
              <Award className="h-16 w-16 text-yellow-400/50 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-white mb-2">Aucun événement trouvé</h3>
              <p className="text-gray-400 max-w-md mx-auto">
                Aucun événement n'est disponible pour le moment.
              </p>
            </div>
          )}
        </div>
      </div>
    </PublicLayout>
  );
};

export default EventsPage;
